import React from 'react';

import { FooterIcon } from './Footer.types';
import { LinkedinIcon, TelegramIcon, TwitterIcon } from 'src/packages/icons/social';
import { DarkTheme } from 'src/packages/theme';
import { config } from 'src/config';

export const footerIcons: FooterIcon[] = [
  /*  {
    label: 'Facebook',
    icon: <Facebook size={30} color={DarkTheme.colors.text.tertiary} />,
    onClick: () => goToUrl(config.facebookUrl, '_blank'),
  },
  {
    label: 'YouTube',
    icon: <Instagram size={30} color={DarkTheme.colors.text.tertiary} />,
    onClick: () => goToUrl(config.instagramUrl, '_blank'),
  },*/
  /*  {
  label: 'Medium',
  icon: <Medium size={30} color={DarkTheme.colors.text.tertiary} />,
  onClick: () => goToUrl(config.mediumUrl, '_blank'),
},*/
  {
    label: 'X',
    icon: <TwitterIcon size={30} color={DarkTheme.colors.text.tertiary} />,
    url: config.twitterUrl,
  },
  {
    label: 'LinkedIn',
    icon: <LinkedinIcon size={30} color={DarkTheme.colors.text.tertiary} />,
    url: config.linkedinUrl,
  },
  {
    label: 'Telegram',
    icon: <TelegramIcon size={30} color={DarkTheme.colors.text.tertiary} />,
    url: config.telegramUrl,
  },
  // {
  // label: 'Discord',
  //   icon: <DiscordIcon size={30} color={DarkTheme.colors.text.tertiary} />,
  //   url: config.discordUrl,
  // },
];
